<div class="mt-input">
  <label *ngIf="label" class="mt-label">
      <img appImageSelector alt="mt-image" *ngIf="tooltipDescription" imageKey="info" imageType="icon"
          placement="right" [ngbTooltip]="tooltipDescription" class="tooltip-info">
      {{ label }} <span class="required-symbol" *ngIf="requiredField">*</span>
  </label>
  <div class="input-group">
      <div class="input-group-prepend" *ngIf="tagPrepend">
          <span [ngClass]="{'prepend-error': errorMessage}" class="input-group-text" id="basic-addon1">0.451.</span>
      </div>
      <input #mtInput
          class="form-control border-left-0"
          [maxLength]="maxCharLength ? maxCharLength : 80"
          [minLength]="minCharLength"
          [disabled]="isDisabled"
          [type]="type"
          [placeholder]="placeholder"
          [value]="value"
          [ngClass]="{
              blackTheme: theme === INPUT_THEME.DARK,
              redTheme: theme === INPUT_THEME.RED,
              'light-theme': theme === INPUT_THEME.LIGHT,
              'disable-theme': theme === INPUT_THEME.DISABLED || errorMessage,
              'input-large-size': size === 'large',
              'tag-prepend': tagPrepend && !tagSmall,
              'tag-small': tagPrepend && tagSmall,
              'input-error': errorMessage
          }"
          [ngStyle]="{'padding-right': clearable && mtInput.value.length ? '30px' : '12px' }"
          (input)="onInput($event.target)"
          (blur)="onTouched()"
          [appTag]="tagPrepend"
          [appCharRestriction]="charRestriction">

      <img class="input-type pointer" *ngIf="displayIcon" appImageSelector
      [ngStyle]="{'top': inputType === 'search' ? '12px' : '8px', 'z-index': '9' }"
          [imageType]="imageType"
          [imageKey]="imageKey"
          [ngClass]="{  normalIconPosition: size === 'normal',
                        pointer: cursor,
                        'input-type': inputType !== INPUT_TYPE.SEARCH,
                        'input-type-search': inputType === INPUT_TYPE.SEARCH }"
          (click)="clickIcon(mtInput)">

      <img appImageSelector alt="mt-image" *ngIf="clearable && mtInput.value.length" 
      [ngStyle]="{'right': inputType === 'search' ? '30px' : '8px' }"
          class="normalIconPosition pointer"
          [imageType]="'icon'"
          [imageKey]="'x-input-icon'"
          (click)="clearInput()">

      <span class="error-message" *ngIf="errorMessage" [ngClass]="{'error-with-prepend': errorMessage && tagPrepend}">
          <img appImageSelector alt="mt-image" imageKey="alert" imageType="icon">
          <p class="error-message-text" [innerHTML]="errorMessage"></p>
      </span>
      <span class="input-counter" *ngIf="maxCharLength" [ngClass]="{'input-counter-error': errorMessage}"
          [ngStyle]="{'bottom': errorMessage && tagPrepend ? '0px' : '28px'}"  [style.margin-left]="((tagPrepend && !tagSmall) ? '112' :  '93' ) + '%'">
          {{ max((maxCharLength) - (tagPrepend ? mtInput.value.replace('.','').length + 1 : mtInput.value.length || 0), 0) }}
      </span>
  </div>
</div>
